import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useGetTrendingQuery, useGetPopularQuery } from "../../services/homepage";
import ImageList from "@material-ui/core/ImageList";
import ImageListItem from "@material-ui/core/ImageListItem";
import { makeStyles } from "@material-ui/core/styles";
import HomeData from "../../Components/HomeData";
import "react-lazy-load-image-component/src/effects/blur.css";
import HomeCarousel from "../../Components/HomeCarousel";
import HomeProductCards from "../../Components/HomeProductCards";
import HelmetComponent from "../../Components/HelmetComponent";
import { getMetaByCountry } from "../../metaConfig";
import { useMediaQuery } from "react-responsive";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
  },
  imageList: {
    "&::-webkit-scrollbar": {
      display: "none",
    },
    flexWrap: "nowrap",
    transform: "translateZ(0)",
  },
  title: {
    color: theme.palette.primary.light,
  },
  titleBar: {
    background: "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)",
  },
}));

function Home() {
  const { t } = useTranslation();
  const { countryCode } = useSelector((state) => state.auth);
  const isMobcreen = useMediaQuery({ query: "(min-width: 0px) and (max-width: 768px)" });
  const trendingData = useGetTrendingQuery(
    { countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );
  const popularData = useGetPopularQuery(
    { countryCode: countryCode },
    { count: 1 },
    { refetchOnMountOrArgChange: true }
  );

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, []);

  const classes = useStyles();
  let adcPosition;
  if (document.body.dir === "rtl") {
    adcPosition = { left: "10px" };
  } else {
    adcPosition = { right: "10px" };
  }

  const [isMetaTitle, setMetaTitle] = useState("");
  const [isMetaDescription, setMetaDescription] = useState("");
  useEffect(() => {
    const { title, description } = getMetaByCountry(countryCode);
    setMetaTitle(title);
    setMetaDescription(description);
  }, [countryCode]);

  return (
    <>
      <HelmetComponent title={""} metaTitle={isMetaTitle} metaDescription={isMetaDescription} />
      <div className="hp-style">
        <HomeCarousel />

        <div className="container">
          <br />
          <div className="cardTitle">Shop by categories</div>
          <ImageList className={classes.imageList} cols={5}>
            {HomeData?.fashion?.map((item, i) => (
              <ImageListItem className="cardItem" key={i}>
                <Link to={`/search/${item.link}`} className="cardItem-item" style={{ border: "none" }}>
                  <div className="img-card">
                    <img
                      style={{ padding: "0px", borderRadius: "8px", height: "auto" }}
                      className="img-item"
                      src={item?.image}
                      alt={item?.name}
                    />
                  </div>
                </Link>
              </ImageListItem>
            ))}
          </ImageList>
          <br />

          <br />
          {isMobcreen ? (
            <div className={classes.imageList} cols={1}>
              <div className="cardItem-img">
                <Link to={`/search/featured products`} className="cardItem-item" style={{ border: "none" }}>
                  <div className="img-card">
                    <img
                      style={{ padding: "0px", borderRadius: "8px", height: "auto" }}
                      className="img-item"
                      src={"https://d3px821xl4957r.cloudfront.net/assets/images/1786564237170-4-Mobile06.jpg"}
                      alt={""}
                    />
                  </div>
                </Link>
              </div>
            </div>
          ) : (
            <div className={classes.imageList} cols={1}>
              <div className="cardItem-img">
                <Link to={`/search/featured products`} className="cardItem-item" style={{ border: "none" }}>
                  <div className="img-card">
                    <img
                      style={{ padding: "0px", borderRadius: "8px", height: "auto" }}
                      className="img-item"
                      src={"https://d3px821xl4957r.cloudfront.net/assets/images/1786564269163-2-5.jpg"}
                      alt={""}
                    />
                  </div>
                </Link>
              </div>
            </div>
          )}
          <br />

          <br />
          <HomeProductCards
            productData={trendingData.data?.trendings}
            isLoading={trendingData?.isLoading}
            heading={t("INTERNATIONAL BESTSELLERS")}
          />
          <br />
          <div className="cardTitle">Luxura Categories</div>
          <ImageList className={classes.imageList} cols={4}>
            {HomeData?.category_b?.map((item, i) => (
              <ImageListItem className="cardItem" key={i}>
                <Link to={`/search/${item.link}`} className="cardItem-item" style={{ border: "none" }}>
                  <div className="img-card">
                    <img
                      style={{ padding: "0px", borderRadius: "8px", height: "auto" }}
                      className="img-item"
                      src={item?.image}
                      alt={item?.name}
                    />
                  </div>
                </Link>
              </ImageListItem>
            ))}
          </ImageList>
          <br />
          <HomeProductCards
            productData={popularData.data?.popular}
            isLoading={popularData?.isLoading}
            heading={t("popular products")}
          />
          <br />
        </div>
        <br />
      </div>
    </>
  );
}

export default Home;
